import { styled, SvgIcon } from '@ethings/ui-toolkit';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { FC, ReactNode } from 'react';

interface DynamicIconProps {
  'data-testid'?: string;
  icon: ReactNode | undefined;
  size?: string;
  color?: string;
}

type StyledSvgIconBaseProps = SvgIconProps & {
  size?: string;
  styleColor?: string;
};

const StyledSvgIconBase = styled(SvgIcon, {
  shouldForwardProp: (prop) => prop !== 'size' && prop !== 'styleColor',
})<StyledSvgIconBaseProps>(({ size, styleColor }) => ({
  animation: 'opacity 50ms forwards',
  opacity: 0,
  width: size,
  height: size,
  color: styleColor,
  '@keyframes opacity': {
    '100%': {
      opacity: 1,
    },
  },
}));

export const DynamicIcon: FC<DynamicIconProps> = ({ icon, size = '1em', color = 'currentColor', ...props }) => {
  return icon
    ? <StyledSvgIconBase data-testid={props['data-testid']} size={size} styleColor={color}>{icon}</StyledSvgIconBase>
    : <></>;
};
